/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models.jointJs {
    export class DrawingOptions {

        public numberOfBoxes: number;

        public boxWidth: number;
        public boxHeight: number;
        
        public verticalSpacing: number;
        public horizontalSpacing: number;

        public gridSize: number;

        public rectangleColor: string;
        public textColor: string;

        public selectedRectangleColor: string;
        public selectedTextColor: string;

        constructor() {
            
        }

        public calculateWidthRequired(): number {
            return (this.numberOfBoxes * this.boxWidth) + ((this.numberOfBoxes + 1) * this.horizontalSpacing);
        }

        public calculateHeightRequired() : number {
            return (this.boxHeight) + (this.verticalSpacing * 2);
        }

        // boxNumber is zero based index
        public calculateHorizontalPosition(boxNumber: number): number {
            var offset = boxNumber * (this.horizontalSpacing + this.boxWidth);
            return offset + this.horizontalSpacing;
        }
    }
}